import { render } from "./ValidacaoForm.vue?vue&type=template&id=1d004093&scoped=true"
import script from "./ValidacaoForm.vue?vue&type=script&lang=js"
export * from "./ValidacaoForm.vue?vue&type=script&lang=js"

import "./ValidacaoForm.vue?vue&type=style&index=0&id=1d004093&scoped=true&lang=css"
import "./ValidacaoForm.vue?vue&type=style&index=1&id=1d004093&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d004093"]])

export default __exports__